import { useTranslation } from 'react-i18next';

import Tabs, { TabHeader, TabPanels } from 'components/Tabs';

import ClassMapping from './ClassMapping';
import CustomerMapping from './CustomerMapping';
import EmployeeMapping from './EmployeeMapping';
import ServiceMapping from './ServiceMapping';

const MappingTabs = () => {
  const { t } = useTranslation(['common', 'employees', 'integrations']);
  const tabHeaders = [
    { label: t('common:users') },
    { label: t('integrations:quickbooks.customers') },
    { label: t('integrations:quickbooks.serviceItems') },
    { label: t('integrations:classes') },
  ];
  const tabPanels = [
    { panel: <EmployeeMapping /> },
    { panel: <CustomerMapping /> },
    { panel: <ServiceMapping /> },
    { panel: <ClassMapping /> },
  ];

  return (
    <Tabs>
      <TabHeader tabHeaders={tabHeaders} />
      <TabPanels tabPanels={tabPanels} />
    </Tabs>
  );
};
export default MappingTabs;
